import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { Property } from '../types';
import {
  EasmBulkChangeInvestigationStatusDataProvider,
} from '../dataProvider/EasmBulkChangeInvestigationStatusDataProvider';
import { EasmBulkChangeAssigneeDataProvider } from '../dataProvider/EasmBulkChangeAssigneeDataProvider';
import { EasmBulkChangePriorityDataProvider } from '../dataProvider/EasmBulkChangePriorityDataProvider';
import { EasmBulkChangeScanActionDataProvider } from '../dataProvider/EasmBulkChangeScanActionDataProvider';

export class EasmBulkChangePropertyDataProviderFactory extends BaseWebComponentDataProviderFactory {
  public constructor() {
    super();

    this.map.set(Property.SCAN_ACTION, EasmBulkChangeScanActionDataProvider);
    this.map.set(Property.INVESTIGATION_STATUS, EasmBulkChangeInvestigationStatusDataProvider);
    this.map.set(Property.ASSIGNEE, EasmBulkChangeAssigneeDataProvider);
    this.map.set(Property.PRIORITY, EasmBulkChangePriorityDataProvider);
  }
}
